"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recyclingSupplyTrackerMechanical = void 0;
const recyclingSupplyTrackerMechanical = exports.recyclingSupplyTrackerMechanical = {
  RECYCLING_SUPPLY_TRACKER_MECHANICAL: {
    en: {
      title: 'Recycling Supply Tracker (Mechanical)',
      subtitle: 'Access actionable insight for global mechanical recycling markets',
      description: 'Simplify sourcing with our global database of over 2,500 mechanical recycling plants and projects.',
      list: ['Search by location, operational status, output volume, feedstock, type or colour', 'Key recycled plastics including R-PET, R-PP, R-HDPE and R-LDPE', 'Weblinks to suppliers', 'Includes food-grade certifications', 'Up-to-date current and announced capacity']
    },
    zh: {
      title: '回收供应追踪（机械回收）',
      subtitle: '获取针对全球机械回收市场的可行方案',
      description: '全球数据库涵盖2500多套机械回收装置和项目，简化采购策略。',
      list: ['按装置所在地、运行状态、产量、原料、类型或颜色进行查找', '包括R-PET、R-PP、R-HDPE和R-LDPE等主要再生塑料', '提供供应商官网链接', '包括食品级认证信息', '现有和已宣布产能最新情况']
    }
  }
};